import React from 'react';

import './TuringFooter.css'

const TuringFooter = () => {
  return <div className='turing-footer'>© {(new Date()).getFullYear()} Turing Enterprises, Inc.</div>;
}

export default TuringFooter;
